import React from 'react';
import { SelectInput } from 'admin-on-rest';
import { getRituals } from '../restClient';

const RitualsSelect = (props) => {
  const [choices, setChoices] = React.useState([]);

  React.useEffect(() => {
    getRituals().then(rituals => {
      setChoices(rituals.map(item => ({
        id: item.identifier,
        name: item.title,
      })));
    });
  }, [])

  return <SelectInput {...props} choices={choices} allowEmpty={false} />
}

export default RitualsSelect;



// WEBPACK FOOTER //
// ./src/components/ritualsSelect.js